import { __awaiter } from '../../../external_node_modules/tslib/tslib.es6.js';
import { buildUrl } from '../../../utils/buildUrl.js';
import { makeRequest, METHODS } from '../../baseRequest.js';
import { PLATFORMS } from '../../../constants/platforms.js';
import settings from '../../../settings.js';

function webCommitPurchase(transactionId, bindingId, browserInfo, tsv, backendUrl, language) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = buildUrl(settings.webCommitPurchaseUrl, {
            platform: PLATFORMS.WEB,
            language: language ? language : settings.language,
            backendUrl: backendUrl ? backendUrl : settings.backendUrl,
        });
        return makeRequest(METHODS.POST, url, {
            transactionId,
            bindingId,
            browserInfo,
            tsv,
        });
    });
}

export { webCommitPurchase };
//# sourceMappingURL=webCommitPurchase.js.map
